import { Sparkle, Flame } from 'lucide-react';

const TitlePage = ({ title }) => {
  let content;

  switch (title) {
    case 'lancamentos':
      content = (
        <div className="flex items-center gap-2">
          <Sparkle size={35} className="text-green-600" />
          <h1 className="mmb:text-3xl Iphones2:text-4xl md:text-5xl font-bold text-green-600 uppercase">Lançamentos</h1>
        </div>
      );
      break;
    case 'destaques':
      content = (
        <div className="flex items-center gap-2">
          <Flame size={38} className="text-green-600" />
          <h1 className="mmb:text-3xl Iphones2:text-4xl md:text-5xl font-bold text-green-600 uppercase">Destaques</h1>
        </div>
      );
      break;
    default:
      content = null;
  }

  return (
    <div className="flex ml-[1%]  mt-[1%] w-full p-2">
      {content}
    </div>
  );
}

export default TitlePage;
